import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import TrainerHome from "@/pages/dashboard/TrainerHome";
import OwnerHome from "@/pages/dashboard/OwnerHome";
import ClientsList from "@/pages/dashboard/ClientsList";
import TrainersList from "@/pages/dashboard/TrainersList";
import AuditLog from "@/pages/dashboard/AuditLog";
import Security from "@/pages/dashboard/Security";
import Signup from "@/pages/Signup";
import Pay, { PaymentSuccess } from "@/pages/Pay";
import ClientHome from "@/pages/dashboard/ClientHome";
import Animals from "@/pages/dashboard/Animals";
import QuickEntry from "@/pages/dashboard/QuickEntry";
import BestPractices from "@/pages/dashboard/BestPractices";
import BestPracticeDetail from "@/pages/dashboard/BestPracticeDetail";
import AdminBestPractices from "@/pages/dashboard/AdminBestPractices";
import HealthRecords from "@/pages/dashboard/HealthRecords";
import Reproduction from "@/pages/dashboard/Reproduction";
import CalendarView from "@/pages/dashboard/CalendarView";
import Nutrition from "@/pages/dashboard/Nutrition";
import Analytics from "@/pages/dashboard/Analytics";
import ExpertRequests from "@/pages/dashboard/ExpertRequests";
import LegalPage from "@/pages/LegalPage";
import { LanguageProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import PWAManager from "@/components/PWAManager";
import HelpChatBubble from "@/components/HelpChatBubble";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import "@/App.css";

function ClientHelpBubbleGuard() {
  const { user } = useAuth();
  if (!user || user.role !== "client") return null;
  return <HelpChatBubble />;
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-[#FAFAF7] text-[#1C3A27]">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/pay" element={<Pay />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/dashboard/client" element={<ClientHome />} />
              <Route path="/dashboard/client/animals" element={<Animals />} />
              <Route path="/dashboard/client/quick-entry" element={<QuickEntry />} />
              <Route path="/dashboard/best-practices" element={<BestPractices />} />
              <Route path="/dashboard/best-practices/:bpId" element={<BestPracticeDetail />} />
              <Route path="/dashboard/owner/best-practices" element={<AdminBestPractices />} />
              <Route path="/dashboard/client/health" element={<HealthRecords />} />
              <Route path="/dashboard/client/reproduction" element={<Reproduction />} />
              <Route path="/dashboard/client/calendar" element={<CalendarView />} />
              <Route path="/dashboard/client/nutrition" element={<Nutrition />} />
              <Route path="/dashboard/client/analytics" element={<Analytics />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/dashboard/owner" element={<OwnerHome />} />
              <Route
                path="/dashboard/owner/clients"
                element={<ClientsList scope="owner" />}
              />
              <Route
                path="/dashboard/owner/trainers"
                element={<TrainersList />}
              />
              <Route path="/dashboard/owner/audit" element={<AuditLog />} />
              <Route path="/dashboard/owner/security" element={<Security />} />
              <Route path="/dashboard/trainer" element={<TrainerHome />} />
              <Route
                path="/dashboard/trainer/clients"
                element={<ClientsList scope="trainer" />}
              />
              <Route
                path="/dashboard/trainer/security"
                element={<Security />}
              />
              <Route
                path="/dashboard/owner/expert-requests"
                element={<ExpertRequests />}
              />
              <Route
                path="/dashboard/trainer/expert-requests"
                element={<ExpertRequests />}
              />
              <Route path="/legal/cgu" element={<LegalPage doc="cgu" />} />
              <Route path="/legal/mentions" element={<LegalPage doc="mentions" />} />
              <Route path="/legal/privacy" element={<LegalPage doc="privacy" />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <PWAManager />
          <ImpersonationBanner />
          <ClientHelpBubbleGuard />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}
